import React from "react";
import PropTypes from "prop-types";

const Spinner = ({ children }) => (
  <div className="spinner">
    <span>{children ? children : "Laddar"}</span>
    <div />
  </div>
);

Spinner.defaultProps = {
  children: null
};

Spinner.propTypes = {
  children: PropTypes.string
};

export default Spinner;
